import React, { useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import { AppContext } from "../../App";
import { useHistory } from 'react-router-dom';
import { routerBasePath } from '../../constants/Config';


const contentLabelPaddingLeft = 17;

const useStyles = makeStyles({
    title: {
        fontWeight: 500,
        fontSize: "1.1rem",
        color: "black",
        paddingLeft: "0.5rem",
        verticalAlign: "middle"
    },
    closeIcon: {
        padding: "0px"
    },
    iconContainer: {
        display: "none"
    },
    titleContainer: {
        color: "#007fa3",
        padding: "1.1rem 0.5rem",
        cursor: "pointer",
        borderBottom: "1px solid #f5f5f5"
    },
    item: {
        padding: "0.5rem 0rem"
    },
    rootSelected: {
        padding: "0.5rem 0rem",
        fontWeight: "600"
    },
    group: {
        marginLeft: "0px"
    },
    content: {
        paddingLeft: `${contentLabelPaddingLeft}px`
    },
    subContent: {
        paddingLeft: `${contentLabelPaddingLeft * 2}px`
    },
    label: {
        background: "transparent !important",
        fontWeight: "inherit"
    },
    childRootSelected: {
        borderLeft: "3px solid #9e007e!important",
        fontWeight: "600"
    },
    childGroup: {
        fontWeight: "initial"
    }
});

export default function MobileMenu(props) {
    const classes = useStyles();
    const history = useHistory();
    const { entities, isOnlyStudentHomeSpa, setSelectedpath, selectedpath } = useContext(AppContext);

    useEffect(() => {
        const currentUrl = window.location.href;
        setSelectedpath(currentUrl.includes('/courseInstance') ? '/courseInstance' : (currentUrl.includes('/tasks') ? '/tasks' : ""));
    }, [])

    const clickHandler = (event, path, spaId) => {
        event.preventDefault();
        isOnlyStudentHomeSpa && history.push(`${routerBasePath}/application/${encodeURIComponent(spaId)}${path === '/tasks' ? '/tasks/list' : path}`)
        setSelectedpath(path);
        if (props.selectedSpaId !== spaId) {
            props.setSelectedSpaId(spaId);
        }
        props.setMobileOpen(false);
    }

    const spaClickHandler = (ev, spaId, description) => {
        if (props.selectedSpaId === spaId) return
        props.setSelectedSpaId(spaId)
        if (!props.spaRoutes?.[description]) {
            props.setMobileOpen(false)
        }
        setSelectedpath("");
    }

    const getSubMenus = (parentNavItem) => (
        props.spaRoutes?.[parentNavItem.description]?.map((sub, index) => (
            <TreeItem
                key={`${parentNavItem.spaId}_${index}`}
                nodeId={`${index}`}
                label={entities.decode(sub.label)}
                classes={!isOnlyStudentHomeSpa ? { iconContainer: classes.iconContainer, root: selectedpath === sub.path ? classes.rootSelected : classes.item, expanded: classes.rootSelected, group: classes.group, content: classes.content, label: classes.label } : { iconContainer: classes.iconContainer, content: classes.subContent, label: classes.label, root: props.activePath === sub.path ? classes.childRootSelected : null }}
                onLabelClick={(ev) => clickHandler(ev, sub.path, parentNavItem.spaId)}
            />
        ))
    )

    const handelHomeMenuClick = () => {
        props.onClose();
        props.setSelectedSpaId('dashboard');
        setSelectedpath("");
    }

    return (<div className={classes.root}>
        <div className={classes.titleContainer} >
            <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={props.onClose}
                className={classes.closeIcon}
            >
                <CloseIcon />
            </IconButton>
            <span className="screen-reader-only">opens the to visualize the menu text</span>
            <span className={classes.title}>Menu</span>
        </div>

        {isOnlyStudentHomeSpa ? (
            <TreeView
                classes={{ root: classes.childGroup }}>
                {getSubMenus(props.navItems?.[0])}
            </TreeView> 
            ) :
            (<TreeView defaultExpanded={['dashboard']}>
                <TreeItem
                    className={`mobileDashboardLink ${props.selectedSpaId === 'dashboard' && 'active'}`}
                    key={"dashboard"}
                    nodeId={"dashboard"}
                    label={"Home"}
                    classes={{ root: props.selectedSpaId === 'dashboard' ? classes.rootSelected : classes.item}}
                    onLabelClick={handelHomeMenuClick}
                >
                </TreeItem>
                {/* show item or subitem */}
                {props.navItems?.map((item) => (
                    !(props.spaRoutes?.[item.description]?.length) ?
                        (<TreeItem
                            key={item.spaId}
                            nodeId={item.spaId}
                            label={entities.decode(item.name)}
                            classes={{ iconContainer: classes.iconContainer, root: props.selectedSpaId === item.spaId ? classes.rootSelected : classes.item, expanded: classes.rootSelected, group: classes.group, content: classes.content, label: classes.label }}
                            onLabelClick={(ev) => spaClickHandler(ev, item.spaId, item.description)}
                        >
                        </TreeItem>)
                        :
                        (getSubMenus(item))
                ))}
                <TreeItem
                    className='mobileAdminLink'
                    key={"admin"}
                    nodeId={"admin-link"}
                    label={"Admin"}
                    onLabelClick={(e) => props.adminLinkClickHandler(e)}
                >
                </TreeItem>
            </TreeView>)}
    </div>);
}
